import { Component, Input, OnInit } from '@angular/core';
import { Form } from '../../../_forms';
import { AlertService, EmailTemplateService } from '../../../_services';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AutoResponderEditors, EmailTemplate, EmailTemplateType, getEmailPathVariables } from '../../../_models';
import { FormBuilder, Validators } from '@angular/forms';
import * as tinymce from 'tinymce';

@Component({
  templateUrl: './email-template-popup.component.html',
  selector: 'app-email-template-popup',
  styleUrls: ['./autoresponder-response.component.scss'],
})
export class EmailTemplatePopupComponent extends Form implements OnInit {
  @Input('template') template: EmailTemplate = null;
  @Input('isDefault') isDefault: boolean = false;
  @Input('operationLoading') operationLoading: boolean = false;

  pathVariables = getEmailPathVariables();
  autoResponderEditors = AutoResponderEditors;

  constructor(
    protected alertService: AlertService,
    protected router: Router,
    protected location: Location,
    protected formBuilder: FormBuilder,
    protected templateService: EmailTemplateService
  ) {
    super(alertService, router, location);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      id: [null],
      name: [null, Validators.required],
      type: [EmailTemplateType.AutoResponder, Validators.required],
      subject: [null, Validators.required],
      body: [null, Validators.required],
    });
    super.ngOnInit();

    if (this.template) {
      this.form.patchValue(this.template);
    }

    if (this.isDefault) {
      this.populateDefaultInboundResponseContent();
    }
  }

  getFormData() {
    if (this.form.valid) {
      return this.form.value as EmailTemplate;
    }

    return null;
  }

  populateDefaultInboundResponseContent() {
    this.loading = true;
    this.templateService.getDefaultInboundResponse().subscribe(
      (data: EmailTemplate) => {
        if (data) {
          this.loading = false;
          this.form.patchValue({ subject: data.subject, body: data.body });
        }
      },
      (error) => {
        this.loading = false;
        this.handleError(error);
      }
    );
  }

  emailBodyEditor = {
    plugins: 'root-style image media path-link lists',
    toolbar:
      'bold italic underline strikethrough | alignleft alignright aligncenter alignjustify alignnone | numlist bullist | styleselect forecolor backcolor | root-style image media | path-link',
    paste_as_text: true,
    min_height: 200,
    max_height: 500,
  };

  addVariable(event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = event.target.value;

    const editorInstance = tinymce.get(this.autoResponderEditors.EmailBody);
    if (editorInstance) {
      editorInstance.insertContent(selectedValue);
    }

    selectElement.selectedIndex = 0;
  }
}
